import toComparisonShape from 'utils/pivot/plan/toComparisonShape'

function parsePlanFromResponse(
  responsePlans,
  planId: string,
  period: number,
  policies: number
): ComparePage.Plan {
  return toComparisonShape({
    plan: responsePlans.plans[planId],
    allPlans: responsePlans.plans,
    brochures: responsePlans.brochures,
    carriers: responsePlans.carriers,
    period,
    policies
  })
}

export default parsePlanFromResponse
